<template>
    <!--纵向流程-->
    <div class="process" v-if="processType!='1'">
        <ul class="pro_main main">
            <li class="pro_icon main" v-for="(item,index) in model.nodeList" :key="index">
                {{item.nodename}}
                <ul class="prolc_text">
                    <template v-for="(li, index) in item.child">
                        <li @click="$emit('click',li)" :key="index" v-if="li.nodetype=='1'">
                            <div 
                            :title="li.isshow==='1' ? li.nodeurl : ''"  
                            :class="{'isnew': li.isnew==='1'&&li.isshow==='1'}">
                                {{li.nodename}}
                            </div>
                            <span class="prolc_text_icon"></span>
                        </li>
                    </template>
                </ul>
            </li>
        </ul>
        <el-divider>
            <span class="break-text">↑主要流程</span>
            <span class="break-text">附加流程↓</span>
        </el-divider>
        <ul class="pro_main sub">
            <li class="pro_icon sub" v-for="(item,index) in model.nodeList" :key="index">
                {{item.nodename}}
                <ul class="prolc_text">
                    <template v-for="(li, indexIn) in item.child">
                        <li @click="$emit('click',li)" :key="indexIn" v-if="li.nodetype=='2'">
                            <div 
                            :title="li.isshow==='1' ? li.nodeurl : ''"  
                            :class="{'red': li.isclick=='css','isnew': li.isnew==='1'&&li.isshow==='1'}">
                                {{li.nodename}}
                            </div>
                        
                        </li>
                    </template>
                </ul>
            </li>
        </ul>
    </div>
    <!--横向流程-->
    <div class="transverse" v-else>
        <ul class="tranMain">
            <div class="tranCon" v-for="(item,index) in model.nodeList" :key="index">
                <el-row>
                    <el-col :span="3">
                        <label>{{item.nodename}}</label>
                    </el-col>
                    <el-col :span="21">
                        <ul class="prolc_text">
                            <template v-for="(li, indexIn) in item.child">
                                <li @click="$emit('click',li)" :key="indexIn" v-if="li.nodetype=='1'" class="lczhu">
                                    <div 
                                    :title="li.isshow==='1' ? li.nodeurl : ''"  
                                    :class="{'isnew': li.isnew==='1'&&li.isshow==='1'}">
                                        {{li.nodename}}
                                    </div>
                                    
                                </li>
                                
                            </template>
                        </ul>
                        <ul class="prolc_text">
                            <template v-for="(li, index) in item.child">
                                
                                <li @click="$emit('click',li)" :key="index" v-if="li.nodetype=='2'" class="lcfu">
                                    <div 
                                    :title="li.isshow==='1' ? li.nodeurl : ''"  
                                    :class="{'red': li.isclick=='css','isnew': li.isnew==='1'&&li.isshow==='1'}">
                                        {{li.nodename}}
                                    </div>
                                
                                </li>
                            </template>
                        </ul>
                    </el-col>
                </el-row>
             
            </div>
            
        </ul>
    </div>
</template>

<script>



export default {
    props: {
        model: {
            type: Object,
            default: () => ({})
        }
    },
    data() {

        return{
            processType:window._config.processType
        }
    },
    computed: {
        id: function() {
            return this.getQuery('id') || '';
        },
    },
    watch: {
     
    },
    methods: {
        

    },
    created() {
        
    },
    mounted() {
        var that = this
    }
}
</script>

<style scoped lang="scss">

</style>
